import { Dialog } from '@base-ui-components/react/dialog'
import * as React from 'react'
import { DialogContext } from './dialog-context'

export function DialogRoot({
  dismissible = true,
  open: openProp,
  onMounted,
  onOpenChange,
  ...props
}: DialogRoot.Props) {
  const [open, setOpen] = React.useState(openProp ?? false)

  React.useEffect(() => {
    onMounted?.()
  }, [])

  React.useEffect(() => {
    setOpen(openProp ?? false)
  }, [openProp])

  return (
    <DialogContext.Provider value={{ dismissible, open, setOpen }}>
      <Dialog.Root
        dismissible={dismissible}
        open={open}
        onOpenChange={(open, event, reason) => {
          if (typeof openProp === 'undefined') setOpen(open)
          onOpenChange?.(open, event, reason)
        }}
        {...props}
      />
    </DialogContext.Provider>
  )
}

export namespace DialogRoot {
  export interface Props extends Dialog.Root.Props {
    onMounted?: () => void
  }
}
